///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";
import { every } from "lodash";

import laneViewColumns from "../../../helpers/laneViewColumns";
import { analyticsView } from "../../../helpers/types";
import {
  filterLoads,
  setColumnWidth,
  setLoadView,
  sortLoads,
  toggleColumnFilterMenu
} from "../../../slices/analyticsSlice";
import LanesGridBody from "../pricing/LanesGridBody";
import PricingGridHeader from "../pricing/PricingGridHeader";

export const LaneViewGrid = ({ division }) => {
  const {
    analytics: {
      selectedRowIndex,
      selectedButtonIndex,
      laneView: {
        lanes: groupedByLane,
        columnFilterMenu,
        columnFilters,
        rangeFilters,
        columnWidths,
        sortField,
        sortOrder
      }
    },
    bidSummary: { summary }
  } = useSelector(state => state);

  const areAllLoadsExcluded = every(
    groupedByLane?.filter(x => x.metaData.matched === true),
    { exclude: "Include" }
  );

  return (
    <div
      data-testid="lane-view-grid"
      className="analytics-table-width"
      id="analytics-grid-laneView"
    >
      <div
        style={{ maxHeight: window.screen.height - 240 }}
        className="overflow-x--scroll scroll"
      >
        <table className="bg-white pl-16 pos-relative">
          <PricingGridHeader
            columns={laneViewColumns}
            columnOrder={laneViewColumns.map(m => m.field)}
            sortField={sortField}
            sortOrder={sortOrder}
            columnFilterMenu={columnFilterMenu}
            columnFilters={columnFilters}
            rangeFilters={rangeFilters}
            columnWidths={columnWidths}
            analyticsGridView={analyticsView.laneView}
            setColumnWidth={setColumnWidth}
            toggleColumnFilterMenu={toggleColumnFilterMenu}
            filterPricingLanes={filterLoads}
            sortPricingLanes={sortLoads}
            bidDivision={division ?? summary?.division}
            buttonLabelValue={areAllLoadsExcluded}
          />
          {groupedByLane && (
            <LanesGridBody
              columns={laneViewColumns}
              lanes={groupedByLane}
              offset={0}
              perPage={groupedByLane.length}
              columnOrder={laneViewColumns.map(m => m.field)}
              bidDivision={division ?? summary?.division}
              analyticsGridView={analyticsView.laneView}
              onRowClick={setLoadView}
              selectedRowIndex={selectedRowIndex}
              selectedButtonIndex={selectedButtonIndex}
            />
          )}
        </table>
      </div>
    </div>
  );
};

export default LaneViewGrid;
